const Bookings = () => {
  return (
    <p>Bookings (out of scope)</p>
  )
}

export default Bookings;